import React, { Component } from 'react';
import { connect } from "react-redux";
import {IUsageArea} from "../../models/usage-analytics/ISchoolUsageSummary";
import LoadingCard from '../LoadingCard';
import IUsageMarkScheme from '../../models/usage-analytics/IUsageMarkScheme';
import ApiService from '../ApiService';
import { AreaUsageCalculationExplanation } from './AreaUsageCalculationExplanation';
import { IRootState } from '../../store';

interface AreaUsageCalculationExplanationsProps {
    apiService: ApiService;
}

interface AreaUsageCalculationExplanationsState {
    areaUsageMarkSchemes?: { [key in IUsageArea]: IUsageMarkScheme }
    areaUsageCalcalationExplanations?: { [key in IUsageArea]: string }
}

class AreaUsageCalculationExplanations extends Component<AreaUsageCalculationExplanationsProps, AreaUsageCalculationExplanationsState> {
    static displayName = AreaUsageCalculationExplanations.name;

    constructor(props: AreaUsageCalculationExplanationsProps) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount(): Promise<void> {
        const explanations = await this.props.apiService.getCalculationExplanationsForSchools();
        const markScheme = await this.props.apiService.getCalculationThresholdsForSchools();

        this.setState({
            areaUsageMarkSchemes: markScheme,
            areaUsageCalcalationExplanations: explanations
        });
    }

    componentDidUpdate(prevProps: Readonly<AreaUsageCalculationExplanationsProps>, prevState: Readonly<AreaUsageCalculationExplanationsState>, snapshot?: any): void {

    }

    render() {

        if (this.state.areaUsageMarkSchemes === undefined || this.state.areaUsageCalcalationExplanations === undefined) {

            return <LoadingCard text={"Loading..."} />;
        }

        return (
            <div className="area-usage-summary-charts-card">
                <div className="card__header">
                    <span className="card__title">
                        Explanations
                    </span>

                    {this.props.children}
                </div>
                <div className="area-usage-explanations-container">
                    <AreaUsageCalculationExplanation Title="Subject Usage" Explanation={this.state.areaUsageCalcalationExplanations[IUsageArea.subject]} MarkScheme={this.state.areaUsageMarkSchemes[IUsageArea.subject]} />                  
                    <AreaUsageCalculationExplanation Title="Assignment Usage" Explanation={this.state.areaUsageCalcalationExplanations[IUsageArea.assignment]} MarkScheme={this.state.areaUsageMarkSchemes[IUsageArea.assignment]} />                   
                    <AreaUsageCalculationExplanation Title="Notebook Usage" Explanation={this.state.areaUsageCalcalationExplanations[IUsageArea.notebook]} MarkScheme={this.state.areaUsageMarkSchemes[IUsageArea.notebook]} />                    
                    <AreaUsageCalculationExplanation Title="Student Folder Usage" Explanation={this.state.areaUsageCalcalationExplanations[IUsageArea.studentFolders]} MarkScheme={this.state.areaUsageMarkSchemes[IUsageArea.studentFolders]} />                    
                    <AreaUsageCalculationExplanation Title="Home Site Usage" Explanation={this.state.areaUsageCalcalationExplanations[IUsageArea.homeSite]} MarkScheme={this.state.areaUsageMarkSchemes[IUsageArea.homeSite]} />                    
                    <AreaUsageCalculationExplanation Title="Staff Site Usage" Explanation={this.state.areaUsageCalcalationExplanations[IUsageArea.staffSite]} MarkScheme={this.state.areaUsageMarkSchemes[IUsageArea.staffSite]} />                    
                    <AreaUsageCalculationExplanation Title="Training Site Usage" Explanation={this.state.areaUsageCalcalationExplanations[IUsageArea.trainingSite]} MarkScheme={this.state.areaUsageMarkSchemes[IUsageArea.trainingSite]} />                    
                </div>                
            </div>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: {}): AreaUsageCalculationExplanationsProps => {
        return {
            apiService: state.auth.apiService,
        };
    }
)(AreaUsageCalculationExplanations)